var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"},[_c('mini-chart',{attrs:{"points":_vm.points,"plotShadow":true,"margin":{ top: 0, right: 0, bottom: 0, left: 0 },"fixedWidth":this.chartWidth,"fixedHeight":this.chartHeight,"smooth":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }